export const ResizeWindowEventName: string = 'resize-window';

export interface ResizeWindowEventArgs {
    
}

